import React, { useState, useEffect, useRef } from "react";
import { Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import {
  getSchoolReturnsByIdRequest,
  updateSchoolRequest,
} from "../../../../Backend/SchoolsRequests";
import { SchoolStatusCell } from "../../../../Components/SchoolStatusCell/SchoolStatusCell";
import Switch from "../../../../Components/Switch/Switch";
import TableTemplate from "../../../../Components/Table/TableTemplate";
import { WebRoutes } from "../../../../Constants";
import { SCHOOL_BOOKS_PURCHASE } from "../../../../Constants/Endpoints";
import { bookNumberMask } from "../../../../Helpers/utils/utils";
import { hasValue } from "../../../../Helpers/validations/common";
import { FinalizeModal } from "../FinalizeModal/FinalizeModal";
import { BookPurchaseQuantityModal } from "./BookPurchaseQuantityModal/BookPurchaseQuantityModal";
// import { PurchaseFileModal } from "./PurchaseFileModal/PurchaseFileModal";
import "./SchoolBookPurchaseQuantity.scss";

export function SchoolBookPurchaseQuantity() {
  const tableTemplateRef = useRef(null);
  const [t] = useTranslation();
  const navigate = useNavigate();
  const { schoolId, id } = useParams();
  const [scanMode, setScanMode] = useState(true);

  const [highlightValues, setHighlightValues] = useState([]);
  const [highlightKey] = useState("id");

  const [showFinalizeModal, setShowFinalizeModal] = useState(false);
  const [purchaseFileModal, setPurchaseFileModal] = useState(false);
  const [school, setSchool] = useState({
    id: "",
    year: 0,
    completed: false,
    schoolId: "",
    school: {
      id: "",
      schoolNumber: 0,
      name: "",
      digiDeliveryId: "",
      schoolDeliveryType: "",
      studentCount: 0,
    },
  });

  const [columns] = useState([
    {
      name: "bookNumber",
      headerCaption: t("BookNumber"),
      caption: (x) => bookNumberMask(x.bookNumber),
      filterPattern: /^(\d+\.?)+$/,
      filterParser: (x) => x.replace(/\./g, ""),
      size: "normal-x",
      canSort: true,
      canFilter: true,
      canEdit: false,
    },
    {
      name: "title",
      headerCaption: t("Title"),
      size: "big",
      canSort: true,
      canFilter: true,
      canEdit: false,
    },
    {
      name: "isbn",
      headerCaption: t("ISBN"),
      size: "normal",
      canSort: true,
      canFilter: true,
      canEdit: false,
    },
    {
      name: "count",
      headerCaption: t("Count"),
      size: "small",
      textAlign: "center",
      canSort: true,
      canFilter: false,
      canEdit: false,
    },
    {
      name: "isScanned",
      headerCaption: t("Scanned"),
      size: "small",
      textAlign: "center",
      canSort: false,
      canFilter: false,
      canEdit: false,
      caption: (x) => (
        <span className="is-checkbox">
          {x.isScanned ? "check_box" : "check_box_outline_blank"}
        </span>
      ),
    },
    {
      name: "purchase",
      headerCaption: t("Purchase"),
      size: "small",
      textAlign: "center",
      canSort: false,
      canFilter: false,
      canEdit: false,
      caption: (x) => (
        <span className="is-checkbox">
          {x.purchase ? "check_box" : "check_box_outline_blank"}
        </span>
      ),
    },
  ]);

  useEffect(() => {
    getSchoolById();
  }, [id]);

  const getSchoolById = async () => {
    const resp = await getSchoolReturnsByIdRequest(schoolId);

    if (resp.success) {
      const schoolData = resp.data.list[0];
      setSchool(schoolData);
    }
  };

  const handleFinalize = async () => {
    const body = {
      id: school.id,
      firstScanCompleted: true,
      secondScanCompleted: true,
      thirdScanCompleted: true,
    };
    const resp = await updateSchoolRequest(body);
    if (resp.success) {
      getSchoolById();
      tableTemplateRef.current.getItems();
      setShowFinalizeModal(false);
    }
  };

  return (
    <div className="school-package-returns-page">
      <div className="header-page-buttons-wrapper">
        <div
          className="goback"
          onClick={() => navigate(-1)}
          role="link"
          id={"goback-button"}
        >
          <div className="icon">arrow_back</div>
          <div className="text">{t("GoBack")}</div>
        </div>
        <div className={"right-wrapper"}>
          {school.secondScanCompleted && (
            <div
              className="summary-btn"
              title={t("Summary")}
              onClick={() =>
                navigate(
                  WebRoutes.SchoolBookSummaryPurchase.replace(
                    ":schoolId",
                    schoolId
                  ).replace(":id", id)
                )
              }
            >
              article
            </div>
          )}
          {school.thirdScanCompleted && (
            <div className="completed">
              <SchoolStatusCell status={school.thirdScanCompleted} />
            </div>
          )}
          <div className="button-save-wrapper">
            <Button
              className="button-save"
              onClick={() => setShowFinalizeModal(true)}
            >
              {t("Finalize")}
            </Button>
          </div>
          <Switch
            label={t("ScanMode")}
            checked={scanMode}
            onChange={setScanMode}
          />
        </div>
      </div>

      <div className={"main-return-wrapper"}>
        {hasValue(school.schoolId) && (
          <div
            className={`${
              scanMode ? "grid-return-wrapper side" : "grid-return-wrapper"
            }`}
          >
            <TableTemplate
              title={t("Books")}
              highlightValues={highlightValues}
              highlightKey={highlightKey}
              subtitle={
                <div className={`school-name-wrapper`}>
                  <div className={`school-type`}>
                    {school.school.schoolDeliveryType}
                  </div>
                  <div className={`school-name`}>{school.school.name}</div>
                </div>
              }
              ref={tableTemplateRef}
              endpoint={
                SCHOOL_BOOKS_PURCHASE +
                "?schoolPackageId=" +
                id +
                "&sortProp=scanDate&descending=true"
              }
              customButtons={
                [
                  // {
                  //   name: t("PurchaseBookFile"),
                  //   action: () => setPurchaseFileModal(true),
                  // },
                ]
              }
              columns={columns}
              uniqueId="schoolNumber"
              paginator={true}
            />
          </div>
        )}
        {hasValue(school.schoolId) && (
          <div
            className={`${
              scanMode
                ? "book-return-side-wrapper side"
                : "book-return-side-wrapper"
            }`}
          >
            <BookPurchaseQuantityModal
              school={school}
              updateGrid={() => tableTemplateRef.current.getItems()}
              highlightValue={(id) => setHighlightValues([id])}
              onSubmit={(id) => {
                tableTemplateRef.current.getItems();
                setHighlightValues([id]);
              }}
            />
          </div>
        )}
      </div>

      {showFinalizeModal && (
        <FinalizeModal
          show={showFinalizeModal}
          submit={() => handleFinalize()}
          onHide={() => setShowFinalizeModal(false)}
        />
      )}

      {/* {purchaseFileModal && (
        <PurchaseFileModal
          show={purchaseFileModal}
          submit={() => tableTemplateRef.current.getItems()}
          onHide={() => setPurchaseFileModal(false)}
        />
      )} */}
    </div>
  );
}
